import React from 'react';
import deepmerge from 'deepmerge';
import Chart from '../../../CommonComponents/Chart';
import { NET_WORTH_CHART_BASE_CONFIG } from './NetWorthChartConstants';

const options = deepmerge(NET_WORTH_CHART_BASE_CONFIG, {
  series: [
    {
      name: 'Assets',
      color: '#eaeaea',
      data: [2, 0, 0],
    },
    {
      name: 'Liabilities',
      color: '#eaeaea',
      data: [0, 3, 0],
    },
    {
      name: 'NetWorth',
      color: '#eaeaea',
      data: [0, 0, 4],
    },
  ],
  xAxis: {
    categories: ['Assets', 'Liabilities', 'Net Worth'],
    labels: {
      enabled: false,
    },
  },
  yAxis: {
    labels: {
      enabled: false,
    },
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    series: {
      animation: false,
    },
  },
});

interface Props {}

export const NetWorthChartLoading: React.FC<Props> = () => {
  return <Chart options={options} />;
};
